import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";

type Svc = { slug: string; label: string; keywords: RegExp };

// Core services we want to cross-link from articles → service pages.
const SERVICES: Svc[] = [
  { slug: "vat-registration", label: "VAT Registration (BIN)", keywords: /\b(vat\s*registration|bin\b|মূসক|ভ্যাট\s*রেজিস্ট্রেশন|বিন)\b/i },
  { slug: "vat-return", label: "VAT Return (Mushak 9.1)", keywords: /\b(vat\s*return|mushak|musak|মুসক|ভ্যাট\s*রিটার্ন)\b/i },
  { slug: "tin-certificate", label: "TIN Certificate (e-TIN)", keywords: /\b(tin|e-?tin|টিন|ই-?টিআইএন)\b/i },
  { slug: "income-tax-return", label: "Income Tax Return 2026-2027", keywords: /\b(income\s*tax|tax\s*return|আয়কর|ট্যাক্স\s*রিটার্ন)\b/i },
  { slug: "trade-license", label: "Trade License", keywords: /\b(trade\s*license|ট্রেড\s*লাইসেন্স)\b/i },
  { slug: "company-registration", label: "Company Registration", keywords: /\b(company\s*registration|rjsc|কোম্পানি\s*রেজিস্ট্রেশন)\b/i },
];

export function ContextualServiceLinks({
  title,
  body,
  category,
}: {
  title?: string | null;
  body?: string | null;
  category?: string | null;
}) {
  const haystack = [title, body, category].filter(Boolean).join(" \n ");
  if (!haystack.trim()) return null;

  const matched = SERVICES.filter((s) => s.keywords.test(haystack)).slice(0, 4);
  // Always link to packages + contact as a fallback so every article carries
  // at least one path into the core funnel.
  if (matched.length === 0) matched.push(SERVICES[3], SERVICES[0]);

  return (
    <aside aria-label="Related services" className="mt-10 pt-6 border-t">
      <h2 className="font-display font-bold text-xl mb-3">Related Services</h2>
      <ul className="flex flex-wrap gap-2">
        {matched.map((s) => (
          <li key={s.slug}>
            <Link
              to="/services"
              className="inline-flex items-center gap-1 rounded-full border px-3 py-1.5 text-sm hover:bg-muted transition-colors"
            >
              {s.label} <ArrowRight className="h-3.5 w-3.5" />
            </Link>
          </li>
        ))}
        <li>
          <Link
            to="/packages"
            className="inline-flex items-center gap-1 rounded-full border px-3 py-1.5 text-sm hover:bg-muted transition-colors"
          >
            View Packages & Pricing <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        </li>
        <li>
          <Link
            to="/contact"
            className="inline-flex items-center gap-1 rounded-full border px-3 py-1.5 text-sm hover:bg-muted transition-colors"
          >
            Talk to an Expert <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        </li>
      </ul>
    </aside>
  );
}
